export const widgetRootId = "migrosone-a11y-widget-root";

export type WidgetMountRoot = HTMLElement | ShadowRoot;

export type GetOrCreateWidgetRootInput = {
  document?: Document;
  onCreateHost?: (host: HTMLElement) => void;
  rootId?: string;
};

export type WidgetRootResult = {
  host: HTMLElement;
  mountRoot: WidgetMountRoot;
};

function createHost(document: Document, rootId: string) {
  const host = document.createElement("div");
  host.id = rootId;
  return host;
}

function getMountRoot(host: HTMLElement): WidgetMountRoot {
  if (host.shadowRoot) {
    return host.shadowRoot;
  }

  if (typeof host.attachShadow === "function") {
    return host.attachShadow({ mode: "open" });
  }

  return host;
}

export function getOrCreateWidgetRoot({
  document = globalThis.document,
  onCreateHost,
  rootId = widgetRootId,
}: GetOrCreateWidgetRootInput = {}): WidgetRootResult {
  const existingHost = document.getElementById(rootId);
  const host = existingHost ?? createHost(document, rootId);

  if (!existingHost) {
    onCreateHost?.(host);
    document.body.appendChild(host);
  }

  return {
    host,
    mountRoot: getMountRoot(host),
  };
}
